import { makeApiCall } from "../apiRequest";

export default {
  state: {
    tempTaskList: [],
    templateList: [],
  },
  getters: {
    getTempTask: (state) => state.tempTaskList,
    getTemplate: (state) => state.templateList,
  },
  actions: {
    async addTempTask({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `superAdminTask/save`,
          `POST`,
          payload
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async addTemplete({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `superAdminTemplate/save`,
          `POST`,
          payload
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async getTempTask({ commit }, payload) {
      const response = await makeApiCall(
        "superAdminTask/getAll",
        "POST",
        payload
      );
      if (!response.error) {
        commit("setTempTask", response.data.data);
      }
      return response;
    },
    async getTemplate({ commit }, payload) {
      const response = await makeApiCall(
        "superAdminTemplate/getAll",
        "POST",
        payload
      );
      if (!response.error) {
        commit("setTemplate", response.data.data);
      } 
      return response;
    },
    async deleteTempTask({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `superAdminTask/delete`,
          `DELETE`,
          payload
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async deleteTemplate({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `superAdminTemplate/delete`,
          `DELETE`,
          payload
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  },
  mutations: {
    setTempTask(state, payload) {
      state.tempTaskList = payload;
    },
    setTemplate(state, payload) {
      state.templateList = payload;
    },
  },
};
